import { useState } from "react";
import ProgressBar from './ProgressBar';
import TodoList from './TodoList';
import TodoInput from './TodoInput';
import SortToggle from './SortToggle';

const initialTodos = [
  {
    id: 1,
    text: "Learn React.js",
    completed: true,
    createdAt: 1,
  },
  {
    id: 2,
    text: "Learn Golang",
    completed: false,
    createdAt: 2,
  },
  {
    id: 3,
    text: "Learn Docker11",
    completed: false,
    createdAt: 3,
  },
  {
    id: 4,
    text: "Learn something else",
    completed: false,
    createdAt: 4,
  },
];

const TodoCard = () => {

    const [todos, setTodos] = useState(initialTodos); 
    const [moveDoneToEnd, setMoveDoneToEnd] = useState(false); // toggle 完成的todo狀態

    // 切換單一 todo 的完成狀態
    const handleToggleTodo = (id) => {
      setTodos((prevTodos) =>
        prevTodos.map((todo) =>
          todo.id === id
            ? { ...todo, completed: !todo.completed }
            : todo
        )
      );
    };

    //刪除todo
    const handleDeleteTodo = (id) => {
      setTodos((prevTodos) =>
       prevTodos.filter((todo) => todo.id !== id)
      );
   };

   //新增todo
   const handleAddTodo = (text) => {
      if (!text.trim()) return;

      const newTodo = {
        id: crypto.randomUUID(),
        text: text.trim(),
        completed: false,
        createdAt: Date.now(),
      };
    
      setTodos((prevTodos) => [...prevTodos, newTodo]);
    };

    // toggle 完成的todo
    const handleToggleSort = () => {
       setMoveDoneToEnd((prev) => !prev);
    };

    //利用filter來算todo.completed
   const completedCount = todos.filter((todo) => todo.completed).length;

   //tenary operator, 如果todos.length === 0 就回傳0, 否則就算用completedCount 除todo長度在*100的百分比progress
    const progress =
    todos.length === 0
      ? 0
      : Math.round((completedCount / todos.length) * 100);

    //做 sort排序 對比completed todo
    const visibleTodos = moveDoneToEnd
    ? [...todos].sort((a, b) => {
        if (a.completed === b.completed) {
          return a.createdAt - b.createdAt;
        }
      
        return a.completed ? 1 : -1;
      })
    : [...todos].sort((a, b) => a.createdAt - b.createdAt);

  return (
    <div>
      <ProgressBar progress={progress} />
      <TodoList 
        todos={visibleTodos}
        onToggleTodo={handleToggleTodo}
        onDeleteTodo={handleDeleteTodo}
      />
      <SortToggle 
        moveDoneToEnd={moveDoneToEnd}
        onToggleSort={handleToggleSort}
      />
      <TodoInput onAddTodo={handleAddTodo} />
    </div>
  )
}

export default TodoCard
